import { AdminCategoriesContext } from "../context/AdminCategoriesContext";
import { useContext } from "react";

export const useAdminCategoriesContext = () => {
  const context = useContext(AdminCategoriesContext);

  if (!context) {
    throw Error(
      "useAdminCategoriesContext must be used inside an AdminCategoriesContext"
    );
  }

  return context;
};
